export const columnConfig = (
  charttype,
  seriesdata,
  xaxis,
  charttitle,
  yaxis = "",
  height
) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: charttype,
      height: height ? height + "%" : (9 / 16) * 100 + "%",
      marginBottom: 100,
    },

    title: {
      text: charttitle,
      widthAdjust: -50,
      float: true,
      verticalAlign: "top",
      style: {
        color: "#000000",
      },
    },
    xAxis: {
      categories: xaxis,
    },
    yAxis: {
      title: {
        text: yaxis,
      },
    },
    legend: {
      enabled: false,
    },
    colors: ["#000000"],
    tooltip: {
      enabled: true,
      headerFormat: "",
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.count}</b> ({point.y:.2f}%)</b> of total: {point.total}<br/>',
      formatter: function (e) {
        if (charttype === "pie") {
          let total = 0;
          seriesdata[0].data.map((ele) => {
            total = total + ele[1];
          });
          return (
            this.point.name +
            " : <b>" +
            this.y +
            " (" +
            ((this.y / total) * 100).toFixed(0) +
            "%)</b>"
          );
        }
        return this.x + " : <b>" + this.y.toFixed(0) + "</b>";
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
      },
      column: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          // format: "{point.count} ({point..1f}%)",
          formatter: function () {
            if (this.y !== 0 && this.y > 100) {
              return Math.round((this.y / this.y) * 100) + "%";
            } else if (this.y === 0) {
              return Math.round(this.y) + "%";
            } else {
              return Math.round(this.y) + "%";
            }
          },
        },
      },
    },
    series: seriesdata,
  };
};

export const stackConfig = (
  charttype,
  seriesdata,
  xaxis,
  charttitle,
  yaxis = ""
) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: charttype,
      height: (9 / 12) * 100 + "%",
    },
    title: {
      text: charttitle,
      widthAdjust: -50,
      style: {
        color: "#000000",
      },
    },
    xAxis: {
      categories: xaxis,
    },
    yAxis: {
      title: {
        text: yaxis,
      },
    },
    tooltip: {
      enabled: true,
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        stacking: "percent",
      },
    },
    series: seriesdata,
  };
};

export const pieConf = (p_data, p_text, p_drilldown, p_height) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      // height: p_height ? p_height + "%" : (9 / 12) * 100 + "%",
    },
    title: {
      text: "",
      widthAdjust: -50,
      style: {
        color: "#ededed",
      },
    },
    // tooltip: {
    //   pointFormat:
    //     '<span style="color:#080807">{point.name}</span>: {point.y}</b> of total: {point.total}<br/>',
    // },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:.1f}%</b>",
    },
    accessibility: {},
    plotOptions: {
      pie: {
        // colors: ["#5f9ea0", "#66cdaa", "#a0d6b4", "#008080"],
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          formatter: function () {
            return Math.round(this.y) + "%";
          },
        },
        showInLegend: false,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "",
        data: p_data,
        allowPointSelect: true,
        size: "50%",
        innerSize: "80%",
      },
    ],
    drilldown: {
      series: p_drilldown ? p_drilldown : [],
    },
  };
};
// Create the chart

export const lineConfig = (
  seriesdata,
  xaxis,
  charttitle,
  yaxis = "",
  height
) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "line",
      height: height ? height : (9 / 16) * 100 + "%",
    },
    title: {
      text: charttitle,
      widthAdjust: -50,
      style: {
        color: "#ffc107",
      },
    },
    xAxis: {
      categories: xaxis,
      visible: true,
      gridLineWidth: 0,
    },
    yAxis: {
      gridLineWidth: 0,
      title: {
        text: yaxis,
      },
    },
    legend: {
      enabled: true,
    },
    colors: [
      "#326D72",
      "#90ed7d",
      "#f7a35c",
      "#8085e9",
      "#f15c80",
      "#e4d354",
      "#2b908f",
      "#f45b5b",
      "#91e8e1",
    ],
    tooltip: {
      enabled: true,
      headerFormat: "",
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.count}</b> ({point.y:.2f}%)</b> of total: {point.total}<br/>',
      formatter: function (e) {
        return this.x + " : <b>" + this.y.toFixed(0) + "</b>";
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: 100,
        borderWidth: 0,
        allowPointSelect: false,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
      },
      column: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          // format: "{point.count} (({point.percent:.1f})%)"
          formatter: function () {
            return Math.round(this.y) + "%";
          },
        },
      },
      series: {
        borderWidth: 0,

        allowPointSelect: true,
        size: "20%",
        innerSize: "50%",

        dataLabels: {
          enabled: false,
          format: "{point.y}",
        },
      },
    },
    series: seriesdata,
    exporting: {
      enabled: false,
    },
  };
};

export const drilldownConfig = (
  p_title,
  p_series,
  p_drill,
  height,
  chart_type = "column"
) => {
  return {
    chart: {
      type: chart_type,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      height: height ? height + "%" : (9 / 16) * 100 + "%",
    },

    title: {
      text: p_title,
      widthAdjust: -50,
      style: {
        color: "#ffc107",
      },
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    legend: {
      enabled: false,
    },
    lang: {
      drillUpText: "◁ Back",
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: false,
          format: "{point.y}",
        },
      },
      column: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          color: "red",
          format: "{point.y} %",

          style: {
            textShadow: false,
            textOutline: 0,
            borderWidth: 0,
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    colors: [
      "#326D72",
      "#90ed7d",
      "#f7a35c",
      "#8085e9",
      "#f15c80",
      "#e4d354",
      "#2b908f",
      "#f45b5b",
      "#91e8e1",
    ],
    tooltip: {
      enabled: true,
      headerFormat: "",
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><b>%</b><br/>',
    },
    series: p_series,
    exporting: {
      enabled: false,
    },
    drilldown: {
      // drillUpButton: {
      //   position: {
      //     verticalAlign: "bottom",
      //     width: 390,
      //     height: 230,
      //   }
      // },
      series: p_drill,
    },
  };
};

export const bubbleConfig = (charttype, seriesdata, charttitle, height) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: charttype,
      height: height ? height + "%" : (9 / 16) * 100 + "%",
    },
    title: {
      text: charttitle,
      widthAdjust: -50,
      style: {
        color: "#ffc107",
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      useHTML: true,
      headerFormat: " ",
      pointFormat: "<b>{point.name}:</b> {point.value}",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      packedbubble: {
        minSize: "50%",
        maxSize: "450%",
        zMin: 0,
        zMax: 1000,
        layoutAlgorithm: {
          splitSeries: false,
          gravitationalConstant: 0.02,
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          filter: {
            property: "y",
            operator: ">",
            value: 0,
          },
          style: {
            color: "#fff",
            textOutline: "none",
            fontWeight: "normal",
            fontSize: "13px",
            width: "58px",
            textOverflow: "ellipsis",
          },
        },
      },
    },
    series: seriesdata,
  };
};

const getPointCategoryName = (point, dimension) => {
  var series = point.series,
    isY = dimension === "y",
    axis = series[isY ? "yAxis" : "xAxis"];
  return axis.categories[point[isY ? "y" : "x"]];
};

export const heatConfig = (
  charttype,
  seriesdata,
  xaxis,
  ycategories,
  charttitle,
  height
) => {
  return {
    chart: {
      type: charttype,
      height: height ? height + "%" : (9 / 16) * 100 + "%",
    },
    title: {
      text: charttitle,
      widthAdjust: -50,
      style: {
        color: "#ededed",
      },
    },
    xAxis: {
      categories: ycategories,
    },
    yAxis: {
      categories: xaxis,
      title: null,
      reversed: true,
    },
    legend: {
      enabled: true,
    },
    exporting: {
      enabled: false,
    },
    colorAxis: {
      min: 0,
      minColor: "#36A98A",
      maxColor: "#018058",
    },
    tooltip: {
      formatter: function () {
        return (
          "<b>" +
          getPointCategoryName(this.point, "x") +
          "</b> <br><b>App - " +
          this.point.secondY.app +
          "</b> <br><b>Whatsapp - " +
          this.point.secondY.whatsapp +
          "</b> <br><b>Telegram - " +
          this.point.secondY.telegram +
          "</b> <br><b>Facebook - " +
          this.point.secondY.facebook +
          "</b> <br><b>Bot - " +
          this.point.secondY.bot +
          "</b> <br><b>" +
          getPointCategoryName(this.point, "y") +
          "</b>"
        );
      },
    },
    accessibility: {
      point: {
        descriptionFormatter: function (point) {
          var ix = point.index + 1,
            xName = getPointCategoryName(point, "x"),
            yName = getPointCategoryName(point, "y"),
            val = point.value;
          return ix + ". " + xName + " sales " + yName + ", " + val + ".";
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: seriesdata,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1000,
          },
          chartOptions: {
            yAxis: {
              labels: {
                formatter: function () {
                  return this.value;
                },
              },
            },
          },
        },
      ],
    },
  };
};

export const columnConfigPer = (
  charttype,
  seriesdata,
  xaxis,
  charttitle,
  yaxis = "",
  height
) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: charttype,
      height: height ? height + "%" : (9 / 16) * 100 + "%",
    },
    title: {
      text: charttitle,
      widthAdjust: -50,
      style: {
        color: "#000000",
      },
    },
    xAxis: {
      categories: xaxis,
    },
    yAxis: {
      title: {
        text: yaxis,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      headerFormat: "",
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.count}</b> ({point.y:.2f}%)</b> of total: {point.total}<br/>',
      formatter: function (e) {
        if (charttype === "pie") {
          let total = 0;
          seriesdata[0].data.map((ele) => {
            total = total + ele[1];
          });
          return (
            this.point.name +
            " : <b>" +
            this.y +
            " (" +
            ((this.y / total) * 100).toFixed(0) +
            "%)</b>"
          );
        }
        return this.x + " : <b>" + this.y.toFixed(0) + "</b>";
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
      },
      column: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return Math.round(this.y) + "%";
          },
          //format: "({point.percent:.1f})%",
        },
      },
    },
    series: seriesdata,
    colors: ["#000000"],
  };
};

// open dashboard charts

// trend cases
export const trendSplineConfig = (data) => {
  return {
    chart: {
      type: "spline",
    },
    title: {
      text: "",
      align: "left",
      style: {
        color: "black",
        align: "left",
        textAlign: "left",
      },
    },
    /*subtitle: {
      text: 'Source: ' +
          '<a href="https://en.wikipedia.org/wiki/List_of_cities_by_average_temperature" ' +
          'target="_blank">Wikipedia.com</a>'
  },*/
    xAxis: {
      labels: {
        groupedOptions: [
          {
            style: {
              color: "black", // set red font for labels in 1st-Level
            },
          },
        ],
        //rotation: 90
      },
      categories: data.catagoriesArr,
    },

    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
      },
      spline: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: true,
      },
    },
    series: [
      {
        name: "",
        data: data.chartValues,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
    // exporting: {
    //         buttons: {
    //             contextButton: {
    //              text: '',
    //               symbol: 'url(/sites/all/themes/fastrackcities/images/download-icon.png)',
    //                 symbolStrokeWidth: 1,
    //                 symbolFill: '#bada55',
    //                 symbolStroke: '#330033'
    //             }
    //         }
    //     }
  };
};

// cases report chart
export const barConfig = (data) => {
  return {
    chart: {
      type: "bar",
    },
    title: {
      text: "",
      align: "left",
    },
    /*  subtitle: {
      text: 'Source: <a ' +
          'href="https://en.wikipedia.org/wiki/List_of_continents_and_continental_subregions_by_population"' +
          'target="_blank">Wikipedia.org</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: data.catagoriesArr,
      title: {
        text: null,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        align: "high",
      },

      gridLineWidth: 0,
    },
    plotOptions: {
      bar: {
        /*   borderRadius: '50%', */
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%)",
        },

        /*  groupPadding: 0.1 */
      },
    },

    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        name: "",
        data: data.percentValues,
        color: "#2E75B6",
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// reporting cases
export const reportBarConfig = (data, showLabel) => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "left",
    },
    /*   subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: data.catagoriesArr,
      crosshair: true,
      accessibility: {
        description: "Countries",
      },
      labels: {
        step: showLabel ? 1 : 0,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    plotOptions: {
      column: {
        dataLabels: {
          allowOverlap: showLabel,
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0}%)  ",
          formatter: function (label) {
            if (this.point.index === this.series.points.length - 1)
              return this.y;
          },
        },

        pointPadding: 0.2,
        borderWidth: 0,
      },
    },

    colors: ["#A9D18E"],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        /*  name: 'Corn', */
        color: "#A9D18E",
        data: data.percentValues,
        dataLabels: {
          enabled: true,
          // format: "({point.y:.0f}) {point.percent:.1f}%  ",
        },
        dataLabels: {
          enabled: true,
          // rotation: -90,
          color: "#000",
          // verticalAlign: "top",
          format: "{point.y:.0f} ({point.percent:.0f}%)  ",
          // y: 10, // 10 pixels down from the top
          style: {
            fontSize: "10px",
            fontWeight: "bold",
          },
        },
      },
      /*  {
          name: 'Wheat',
          data: [51086, 136000, 5500, 141000, 107180, 77000]
      } */
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// thematic cases area
export const thematicPieConfig = () => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f}%</span>",
      //  enabled:false,
    },
    /*  subtitle: {
      text:
      'Source:<a href="https://www.mdpi.com/2072-6643/11/3/684/htm" target="_default">MDPI</a>'
  }, */
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          pointFormat: "<span>{point.y:.f}%</span>",
          distance: -30,
          color: "white",
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: [
      {
        name: "Percentage",
        colorByPoint: true,
        showInLegend: true,
        data: [
          {
            name: "Commodities",
            y: 17,
            color: "#74B4EE",
          },
          {
            name: "Human Rights",
            y: 11,
            color: "#FFD919",
          },
          {
            name: "Service Delivery",
            y: 15,
            color: "#89C660",
          },
        ],
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const thematicOpenPieConfig = () => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    /*  subtitle: {
      text:
      'Source:<a href="https://www.mdpi.com/2072-6643/11/3/684/htm" target="_default">MDPI</a>'
  }, */
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          pointFormat: "<span>{point.y:.f}%</span>",
          distance: -30,
          color: "white",
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: [
      {
        name: "Percentage",
        colorByPoint: true,
        showInLegend: true,
        data: [
          {
            name: "Commodities",
            y: 45,
            color: "#74B4EE",
          },
          {
            name: "Human Rights",
            y: 47,
            color: "#FFD919",
          },
          {
            name: "Service Delivery",
            y: 40,
            color: "#89C660",
          },
          {
            name: "Support Groups",
            y: 46,
            color: "#fe6a35",
          },
          {
            name: "Treatment Literacy",
            y: 46,
            color: "#5D8BDD",
          },
        ],
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

const caluculatePercent = (data) => {
  let arr = Object.keys(data);
  let values = Object.values(data);
  let total = values.reduce((partialSum, a) => partialSum + a, 0);

  let series = [];
  let colorIndex = ["#74B4EE", "#FFD919", "#89C660", "#fe6a35", "#5D8BDD"];
  values.map((ele, index) => {
    let percent = ele; //Math.round((ele / total) * 100);
    series = [
      ...series,
      {
        name: arr[index],
        y: percent,
        color: colorIndex[index],
      },
    ];
  });

  return series;
};

export const thematicDeactivatePieConfig = (dataObj) => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "<span>{point.y} ({point.percentage:.0f}%)</span>",
    },
    /*  subtitle: {
      text:
      'Source:<a href="https://www.mdpi.com/2072-6643/11/3/684/htm" target="_default">MDPI</a>'
  }, */
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          pointFormat: "{point.y} ({point.percentage:.0f}%)",
          distance: -30,
          color: "white",
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: [
      {
        name: "Percentage",
        colorByPoint: true,
        showInLegend: true,
        data: caluculatePercent(dataObj),
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const thematicValidatedPieConfig = () => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    /*  subtitle: {
      text:
      'Source:<a href="https://www.mdpi.com/2072-6643/11/3/684/htm" target="_default">MDPI</a>'
  }, */
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          pointFormat: "<span>{point.y:.f}%</span>",
          distance: -30,
          color: "white",
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: [
      {
        name: "Percentage",
        colorByPoint: true,
        showInLegend: true,
        data: [
          {
            name: "Commodities",
            y: 12,
            color: "#74B4EE",
          },
          {
            name: "Human Rights",
            y: 21,
            color: "#FFD919",
          },
          {
            name: "Service Delivery",
            y: 20,
            color: "#89C660",
          },
          {
            name: "Support Groups",
            y: 15,
            color: "#fe6a35",
          },
          {
            name: "Treatment Literacy",
            y: 16,
            color: "#5D8BDD",
          },
        ],
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const thematicOthersPieConfig = () => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    /*  subtitle: {
      text:
      'Source:<a href="https://www.mdpi.com/2072-6643/11/3/684/htm" target="_default">MDPI</a>'
  }, */
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          pointFormat: "<span>{point.y:.f}%</span>",
          distance: -30,
          color: "white",
        },
      },
    },
    credits: {
      enabled: false,
    },

    series: [
      {
        name: "Percentage",
        colorByPoint: true,
        showInLegend: true,
        data: [
          {
            name: "Commodities",
            y: 3,
            color: "#74B4EE",
          },
          {
            name: "Human Rights",
            y: 4,
            color: "#FFD919",
          },
          {
            name: "Service Delivery",
            y: 5,
            color: "#89C660",
          },
          {
            name: "Support Groups",
            y: 3,
            color: "#fe6a35",
          },
          {
            name: "Treatment Literacy",
            y: 3,
            color: "#5D8BDD",
          },
        ],
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// commodities chart
export const commoditiesBarConfig = (data, categoriesArr) => {
  return {
    chart: {
      type: "column",
    },
    legend: {
      symbolRadius: 0,
    },
    title: {
      text: "",
      align: "center",
    },
    /* subtitle: {
      text: 'Source: <a href="https://www.ssb.no/transport-og-reiseliv/landtransport/statistikk/innenlandsk-transport">SSB</a>',
      align: 'left'
  },*/
    xAxis: {
      labels: {
        style: {
          fontWeight: "bold",
        },
      },

      categories: categoriesArr,
    },
    yAxis: {
      stackLabels: {
        enabled: true,
        align: "center",
        // x: 0,
        // y: 2,
        style: {
          color: "white",
          fontSize: "1em",
        },
        formatter: function () {
          // return this.total > 100 ? 100 + "%" : this.total + "%";
        },
      },
      labels: {
        format: "",
      },
      // reversed: true,
      min: 0,
      title: {
        text: "",
        style: {
          fontWeight: "bold",
        },
      },
    },
    tooltip: {
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat: "{series.name}: {point.y} ({point.percent}%)<br/>",
    },
    plotOptions: {
      column: {
        stacking: "percent",
        dataLabels: {
          enabled: false,
          format: "{point.percentage:.0f}%",
        },
      },
    },
    series: data,
    // exporting: {
    //         buttons: {
    //             contextButton: {
    //              text: '',
    //               symbol: 'url(/sites/all/themes/fastrackcities/images/download-icon.png)',
    //                 symbolStrokeWidth: 1,
    //                 symbolFill: '#bada55',
    //                 symbolStroke: '#330033'
    //             }
    //         }
    //     },
    credits: {
      enabled: false,
    },
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 10,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// pilferage/theft cases chart
export const pilferageColumnConfig = () => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "center",
    },
    /* subtitle: {
      text: 'Source: <a ' +
          'href="https://en.wikipedia.org/wiki/List_of_continents_and_continental_subregions_by_population"' +
          'target="_blank">Wikipedia.org</a>',
      align: 'left'
  },*/
    xAxis: {
      categories: [
        "AL",
        "Zidovudine",
        "Microscope",
        "Microscope",
        "Condoms",
        "Condoms",
        "Condoms",
        "Condoms",
        "Bp machine",
      ],
      title: {
        text: null,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        //align: 'high'
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },
    tooltip: {
      valueSuffix: " %",
    },
    plotOptions: {
      column: {
        // borderRadius: '50%',
        dataLabels: {
          enabled: true,
          format: "{point.y:.1f}%",
        },
        groupPadding: 0.1,
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Cases",
        data: [0.6, 0.04, 0.02, 0.1, 0.02, 0.03, 0.06, 0.08, 0.05],
        color: "#A9D18E",

        dataLabels: {
          enabled: true,
          rotation: -90,
          color: "#000",
          verticalAlign: "top",
          format: "{point.y:1f}", // one decimal
          y: 10, // 10 pixels down from the top
          style: {
            fontSize: "10px",
            fontWeight: "normal",
          },
        },
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
    // exporting: {
    //         buttons: {
    //             contextButton: {
    //              text: '',
    //               symbol: 'url(/sites/all/themes/fastrackcities/images/download-icon.png)',
    //                 symbolStrokeWidth: 1,
    //                 symbolFill: '#bada55',
    //                 symbolStroke: '#330033'
    //             }
    //         }
    //     },
  };
};

// stock cases chart
export const stockColumnConfig = (data) => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "center",
    },
    /* subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  },*/

    xAxis: {
      categories: data.catagoriesArr,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    /*  tooltip: {
      valueSuffix: ' (1000 MT)'
  }, */
    plotOptions: {
      column: {
        // borderRadius: '50%',
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%)",
        },
        groupPadding: 0.1,
      },
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        color: "#CAD8EF",
        name: "Consumables",
        data: data.percentValues,
      },
    ],
    //  exporting: {
    //         buttons: {
    //             contextButton: {
    //              text: '',
    //               symbol: 'url(/sites/all/themes/fastrackcities/images/download-icon.png)',
    //                 symbolStrokeWidth: 1,
    //                 symbolFill: '#bada55',
    //                 symbolStroke: '#330033'
    //             }
    //         }
    //     },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// HumanRight related PIE chart
export const genderPieConfig = (data) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: "",
      align: "center",
      verticalAlign: "bottom",
      // y: 60
    },
    credits: {
      enabled: false,
    },
    subtitle: {
      useHTML: true,
      text: `${data.count.number} (${data.count.percent}%)`,
      floating: true,
      verticalAlign: "middle",
      // y: -50,
      style: {
        fontSize: "20px",
        fontweight: "bold",
        color: "black",
      },
    },

    tooltip: {
      // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'.
      pointFormat: `<span>${data.count.number} (${data.count.percent}%)</span>`,
    },
    accessibility: {
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: "bold",
            color: "black",
          },
        },
        //startAngle: -90,
        // endAngle: 90,
        // center: ['50%', '75%'],
        // size: '100%'
      },
    },

    series: [
      {
        type: "pie",
        name: "Value",
        innerSize: "80%",
        /*data: [
          ['Karachi', 73.86],
          ['Hyderabad', 11.97],
          ['Faisalabad', 5.52],
          ['Rawalpindi', 2.98],
          ['Peshawar', 1.90],
          ['Other', 3.77]
      ]*/
        data: [
          {
            name: "",
            y: data.count.percent,
            color: data.color,
          },
          {
            name: "",
            y: 100 - data.count.percent,
            color: "#F0F0F0",
          },
        ],
        showInLegend: false,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const discriminationPieConfig = () => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: "",
      align: "center",
      verticalAlign: "top",
      // y: 60
    },
    credits: {
      enabled: false,
    },
    subtitle: {
      useHTML: true,
      text: "13.6%",
      floating: true,
      verticalAlign: "middle",
      y: 20,
      style: {
        fontSize: "20px",
        fontweight: "bold",
        color: "black",
      },
    },

    tooltip: {
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    accessibility: {
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: "bold",
            color: "black",
          },
        },
        //startAngle: -90,
        // endAngle: 90,
        // center: ['50%', '75%'],
        // size: '100%'
      },
    },

    series: [
      {
        type: "pie",
        name: "Value",
        innerSize: "80%",
        /*data: [
          ['Karachi', 73.86],
          ['Hyderabad', 11.97],
          ['Faisalabad', 5.52],
          ['Rawalpindi', 2.98],
          ['Peshawar', 1.90],
          ['Other', 3.77]
      ]*/
        data: [
          {
            name: "",
            y: 13.6,
            color: "#2E75B6",
          },
          {
            name: "",
            y: 11.0,
            color: "#F0F0F0",
          },
        ],
        showInLegend: false,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const sexualReproPieConfig = () => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: "",
      align: "center",
      verticalAlign: "top",
      // y: 60
    },
    credits: {
      enabled: false,
    },
    subtitle: {
      useHTML: true,
      text: "48.7%",
      floating: true,
      verticalAlign: "middle",
      y: 20,
      style: {
        fontSize: "20px",
        fontweight: "bold",
        color: "black",
      },
    },

    tooltip: {
      // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    accessibility: {
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: "bold",
            color: "black",
          },
        },
        //startAngle: -90,
        // endAngle: 90,
        // center: ['50%', '75%'],
        // size: '100%'
      },
    },

    series: [
      {
        type: "pie",
        name: "Value",
        innerSize: "80%",
        /*data: [
          ['Karachi', 73.86],
          ['Hyderabad', 11.97],
          ['Faisalabad', 5.52],
          ['Rawalpindi', 2.98],
          ['Peshawar', 1.90],
          ['Other', 3.77]
      ]*/
        data: [
          {
            name: "",
            y: 48.7,
            color: "#C30D0D",
          },
          {
            name: "",
            y: 11.0,
            color: "#F0F0F0",
          },
        ],
        showInLegend: false,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

export const neglectPieConfig = () => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: "",
      align: "center",
      verticalAlign: "top",
      // y: 60
    },
    credits: {
      enabled: false,
    },
    subtitle: {
      useHTML: true,
      text: "19.0%",
      floating: true,
      verticalAlign: "middle",
      y: 20,
      style: {
        fontSize: "20px",
        fontweight: "bold",
        color: "black",
      },
    },

    tooltip: {
      // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      pointFormat: "<span>{point.y:.f}%</span>",
    },
    accessibility: {
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: "bold",
            color: "black",
          },
        },
        //startAngle: -90,
        // endAngle: 90,
        // center: ['50%', '75%'],
        // size: '100%'
      },
    },

    series: [
      {
        type: "pie",
        name: "Value",
        innerSize: "80%",
        /*data: [
          ['Karachi', 73.86],
          ['Hyderabad', 11.97],
          ['Faisalabad', 5.52],
          ['Rawalpindi', 2.98],
          ['Peshawar', 1.90],
          ['Other', 3.77]
      ]*/
        data: [
          {
            name: "",
            y: 19.0,
            color: "#203864",
          },
          {
            name: "",
            y: 11.0,
            color: "#F0F0F0",
          },
        ],
        showInLegend: false,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// gbv related cases chart
export const gbvColumnConfig = (data, catagoriesArr) => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "center",
    },
    /* subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: catagoriesArr,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          y: -5,
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%) ",
        },
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        name: "",
        color: "#99ABD9",
        data: data,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// stigma related cases chart
export const stigmaBarConfig = (data, catagoriesArr) => {
  return {
    chart: {
      type: "bar",
    },
    title: {
      text: "",
      align: "center",
    },
    /*  subtitle: {
      text: 'Source: <a ' +
          'href="https://en.wikipedia.org/wiki/List_of_continents_and_continental_subregions_by_population"' +
          'target="_blank">Wikipedia.org</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: catagoriesArr,
      title: {
        text: null,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        //align: 'high'
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },

    plotOptions: {
      bar: {
        // borderRadius: '50%',
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%)",
        },
        groupPadding: 0.1,
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        name: "",
        data: data,
        color: "#2E75B6",
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// sexual reproductive health related cases chart
export const sexualReproBarConfig = (data, catagoriesArr) => {
  return {
    chart: {
      type: "bar",
    },
    title: {
      text: "",
      align: "center",
    },
    /*  subtitle: {
      text: 'Source: <a ' +
          'href="https://en.wikipedia.org/wiki/List_of_continents_and_continental_subregions_by_population"' +
          'target="_blank">Wikipedia.org</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: catagoriesArr,
      title: {
        text: null,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        //align: 'high'
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      bar: {
        // borderRadius: '50%',
        dataLabels: {
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%)",
        },
        groupPadding: 0.1,
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        name: "Cases",
        data: data,
        color: "#2E75B6",
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// neglected related cases chart
export const neglectedCasesBarConfig = (data, catagoriesArr) => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "center",
    },
    /* subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: catagoriesArr,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          y: -5,
          enabled: true,
          format: "{point.y:.0f} ({point.percent:.0f}%)",
        },
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    series: [
      {
        name: "Cases",
        color: "#9DAEDA",
        data: data,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// country reported cases chart
export const countryCasesColumnConfig = () => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "left",
    },
    /* subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: [
        "Kisii",
        "Vihiga",
        "Siaya",
        "Busia",
        "Homa Bay",
        "Nairobi City",
        "Kakamega",
        "Taita/Taveta",
        "Kwale",
        "Migori",
        "Kitui",
        "Turkana",
        "Nakuru",
        "Kisumu",
        "Mombasa",
        "Trans Nzoia",
        "Uasin Gishu",
        "Laikipia",
        "Kilifi",
        "Nyamira",
        "Elegyo/Markawet",
        "Machakos",
        "Tana River",
        "Kajiado",
        "Makueni",
        "West Pokot",
        "Marsabit",
        "Kirinyaga",
        "Kericho",
        "Bungoma",
        "Samburu",
        "Meru",
        "Nyeri",
        "Baringo",
        "Garissa",
        "Nandi",
        "Lamu",
        "Kiambu",
        "Mandera",
        "Nyandarua",
        "Wajir",
        "Muranga",
        "Narok",
        "Bomet",
        "Isiolo",
        "Embu",
      ],
    },
    yAxis: {
      max: 2500,
      title: {
        text: "",
      },
    },
    tooltip: {
      //valueSuffix: ' %'
    },
    plotOptions: {
      column: {
        dataLabels: {
          style: {
            fontSize: "0.5em",
          },
          rotation: 90,
          y: -5,
          enabled: true,
          format: " {point.y:.0f} ({point.percent:.1f}%)",
        },
        pointPadding: 0.2,
        borderWidth: 0,
        fontSize: "2px",
        fontWeight: "normal",
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Cases",
        color: "#C2EAA7",
        data: [
          { percent: 7.7, y: 1837 },
          { percent: 7.2, y: 1731 },
          { percent: 7.2, y: 1725 },
          { percent: 6.8, y: 1640 },
          { percent: 6.4, y: 1533 },
          { percent: 5.8, y: 1392 },
          { percent: 5.5, y: 1309 },
          { percent: 4.8, y: 1137 },
          { percent: 4.6, y: 1090 },
          { percent: 4.2, y: 1007 },
          { percent: 4, y: 964 },
          { percent: 3.8, y: 925 },
          { percent: 3.6, y: 872 },
          { percent: 2.7, y: 648 },
          { percent: 2.6, y: 621 },
          { percent: 2.5, y: 593 },
          { percent: 2.2, y: 512 },
          { percent: 1.5, y: 358 },
          { percent: 1.5, y: 355 },
          { percent: 1.4, y: 330 },
          { percent: 1.3, y: 315 },
          { percent: 1, y: 248 },
          { percent: 0.8, y: 207 },
          { percent: 0.8, y: 203 },
          { percent: 0.7, y: 178 },
          { percent: 0.7, y: 168 },
          { percent: 0.6, y: 150 },
          { percent: 0.6, y: 148 },
          { percent: 0.5, y: 132 },
          { percent: 0.4, y: 115 },
          { percent: 0.4, y: 104 },
          { percent: 0.4, y: 101 },
          { percent: 0.4, y: 99 },
          { percent: 0.4, y: 98 },
          { percent: 0.4, y: 95 },
          { percent: 0.4, y: 89 },
          { percent: 0.4, y: 80 },
          { percent: 0.4, y: 76 },
          { percent: 0.3, y: 65 },
          { percent: 0.3, y: 64 },
          { percent: 0.2, y: 47 },
          { percent: 0.1, y: 23 },
          { percent: 0.1, y: 19 },
          { percent: 0.1, y: 17 },
          { percent: 0, y: 7 },
          { percent: 0, y: 4 },
        ],
        style: {
          fontSize: "2px",
          fontWeight: "normal",
        },
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};

// type of user chart
export const UserCasesColumnConfig = (data) => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "left",
    },
    /* subtitle: {
      text:
          'Source: <a target="_blank" ' +
          'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: 'left'
  }, */
    xAxis: {
      categories: data.catagoriesArr,
    },
    yAxis: {
      // max: 2500,
      title: {
        text: "",
      },
    },
    tooltip: {
      //valueSuffix: ' %'
      pointFormat: "<span>{point.y:.f} <br>({point.percent:.0f}%) </span>",
    },
    plotOptions: {
      column: {
        dataLabels: {
          style: {
            fontSize: "10px",
          },
          // rotation: -90,
          // verticalAlign: "top",
          // y: 0,
          enabled: true,
          pointFormat: "{point.y:.0f} ({point.percent:.0f}%)",
          //  format: '({point.y:.0f}) {point.percent:.1f}%  ',
        },
        // pointPadding: 0.2,
        // borderWidth: 0
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Cases",
        color: "#C2EAA7",
        data: data.percentValues,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          align: "right",
          // x: 50
          x: 0,
          y: -10,
          verticalAlign: "top",
        },
      },
    },
  };
};
